import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import RedirectToTab from "../RedirectToCampaignTab";
import ListPreparatoryCourses from "./List";
import { CAMPAIGNS, CandidateServicePath, COURSES } from "utils/constants";
import CreatePreparatoryCourses from "./Create";
import EditPreparatoryCourses from "./Edit";
import ShowPreparatoryCourses from "./Show";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  isMenu: false,
  tenancies: [tenants.MU],
  icon: <LocalLibraryIcon />,
  name: CandidateServicePath + CAMPAIGNS + `/${COURSES}`,
  title: "Подготвителни курсове",
  list: <RedirectToTab type={COURSES} />,
  tabList: <ListPreparatoryCourses />,
  create: <CreatePreparatoryCourses />,
  createPermission: permissions.canCreateCampaigns,
  edit: <EditPreparatoryCourses />,
  editPermission: permissions.canUpdateCampaigns,
  show: <ShowPreparatoryCourses />,
  showPermission: permissions.canPreviewCampaigns,
  permission: permissions.canPreviewCampaigns,
};
